<template>
  <div>
    <v-card v-bind="$attrs" class="pa-3" rounded="xl">
      <v-card-text
        :class="[titleColor + '--text', { 'pb-0': !!subtitle }]"
        class="d-block"
      >
        <h3 :class="titleColor + '--text'">
          <big v-text="title" />
        </h3>
        <p class="body-1 font-weight-bold" v-if="subtitle" v-text="subtitle" />
      </v-card-text>

      <v-card-text class="pt-0">
        <v-form ref="form" v-model="formIsvalid" lazy-validation>
          <v-row dense no-gutters>
            <v-col cols="12" class="mb-4">
              <v-text-field
                label="Name"
                required
                outlined
                background-color="white"
                persistent-hint
                v-model="formData.name"
                :rules="rules.nameRules"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="mb-4">
              <v-text-field
                label="Email"
                required
                outlined
                background-color="white"
                persistent-hint
                v-model="formData.email"
                :rules="rules.emailRules"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12" class="mb-4">
              <v-text-field
                label="Phone"
                required
                outlined
                background-color="white"
                persistent-hint
                v-model="formData.phone"
                :rules="rules.phoneRules"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                background-color="white"
                :label="commentsLabel"
                v-model="formData.comments"
                required
                outlined
                no-resize
                rows="3"
                dense
              />
            </v-col>
            <v-col cols="12">
              <v-btn :class="submitColor" class="primary--text" dark block>
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-snackbar
      vertical
      xcolor="success"
      xoutlined
      :centered="$vuetify.breakpoint.smAndDown"
      elevation="10"
    >
      <!-- <template v-if="snackbar.type == 'success'">
        <h4>
          <v-icon>mdi-check-circle</v-icon>
          Sent
        </h4>

        <div class="ml-7">
          Our Sales team will get back to you shortly.
          <br />
          For urgent inquiries please call
          <a class="white--text" :href="globals.contactPoints.phone.href">
            +971 58 5466311
          </a>
        </div>
      </template> -->
      <!-- <template v-else>
        <h4>
          <v-icon>mdi-close-circle</v-icon>
          Ooooops...
        </h4>

        <div class="ml-7">
          Something unexpected happened, your message was not sent!
          <br />
          Please call us directly on
          <a class="white--text" :href="globals.contactPoints.phone.href">
            +971 58 5466311
          </a>
        </div>
      </template> -->

      <!-- <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar.visible = false"
        >
          Close
        </v-btn>
      </template> -->
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "portal-form",
  props: [
    "title",
    "titleColor",
    "subtitle",
    "submitColor",
    "commentsLabel",
    "temp",
    "formType",
  ],
  data: () => ({
    formIsvalid: true,
    rules: {
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 3) || "Name must be at least 3 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) => /^[\d ]*$/.test(v) || "Phone must be valid (digits only)",
        (v) =>
          (v && v.replace(/\s/g, "").length >= 9) ||
          "Phone must be at least 9 characters",
      ],
    },

    formData: {
      name: "",
      email: "",
      phone: "",
      comments: "",
    },
    submitting: false,
  }),
  computed: {},
  methods: {},
};
</script>
